import { render, staticRenderFns } from "./TwoFactorAuth.vue?vue&type=template&id=73aa68af&scoped=true"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=ts"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=ts"
import style0 from "./TwoFactorAuth.vue?vue&type=style&index=0&id=73aa68af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aa68af",
  null
  
)

export default component.exports